import React, { useState } from 'react';
import { ArrowDownRight, ArrowUpRight, Download } from 'lucide-react';

const Transactions = ({ userData }: { userData?: any }) => {
  const [filter, setFilter] = useState('All');

  // Dummy transactions
  const transactions = [
    { id: 'TRX98231', type: 'DEPOSIT', amount: 50000, date: '10 Apr 2026, 10:30 AM', status: 'Success' },
    { id: 'TRX98230', type: 'BUY', asset: 'RELIANCE', amount: 42757.50, date: '09 Apr 2026, 02:15 PM', status: 'Success' },
    { id: 'TRX98229', type: 'WITHDRAW', amount: 10000, date: '05 Apr 2026, 11:00 AM', status: 'Pending' },
  ];

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-3xl font-bold text-white">Transactions</h1>
          <p className="text-gray-400 mt-1">View your complete account statement.</p>
        </div>
        <button className="flex items-center gap-2 bg-[#1e222d] border border-gray-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-[#2a2e39] transition-colors">
          <Download size={16} /> Download Statement
        </button>
      </div>

      <div className="bg-[#131b2c] border border-gray-800 rounded-2xl p-6 shadow-xl">
        {/* Filters */}
        <div className="flex gap-4 mb-6 border-b border-gray-800 pb-4 overflow-x-auto">
          {['All', 'Deposits', 'Withdrawals', 'Trades'].map((f) => (
            <button 
              key={f} 
              onClick={() => setFilter(f)}
              className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-colors ${filter === f ? 'bg-blue-600 text-white' : 'bg-[#1e222d] text-gray-400 hover:text-white'}`}
            >
              {f}
            </button>
          ))}
        </div>

        {/* Transaction List */}
        <div className="space-y-4">
          {transactions.map((tx, idx) => (
            <div key={idx} className="flex items-center justify-between p-4 bg-[#0b1221] border border-gray-800 rounded-xl hover:border-gray-700 transition-colors">
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center ${tx.type === 'DEPOSIT' ? 'bg-green-500/10 text-green-500' : tx.type === 'WITHDRAW' ? 'bg-red-500/10 text-red-500' : 'bg-blue-500/10 text-blue-500'}`}>
                  {tx.type === 'DEPOSIT' ? <ArrowDownRight size={24} /> : <ArrowUpRight size={24} />}
                </div>
                <div>
                  <p className="font-bold text-white">{tx.type === 'BUY' ? `Bought ${tx.asset}` : tx.type}</p>
                  <p className="text-xs text-gray-500">{tx.id} • {tx.date}</p>
                </div>
              </div>
              <div className="text-right">
                <p className={`font-bold text-lg ${tx.type === 'DEPOSIT' ? 'text-green-500' : 'text-white'}`}>
                  {tx.type === 'DEPOSIT' ? '+' : '-'}₹{tx.amount.toFixed(2)}
                </p>
                <p className={`text-xs font-bold ${tx.status === 'Success' ? 'text-green-500' : 'text-orange-500'}`}>{tx.status}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Transactions;